import React from "react";
import {Divider} from "@material-ui/core";

const LineComponent = ({component}) => {
    const {styles: sourceStyles} = component;
    const styles = sourceStyles.length ? sourceStyles[0] : {};

    return (
        <div
            style={{
              //  padding: styles.padding,
               // margin: styles.margin
            }}
        >
            <Divider style={{background: styles.color}}
                     variant={styles.fullWidth || 'fullWidth'}/>
        </div>
    )
};

export default LineComponent;